import { Button, Grid } from "@mui/material";
import { Link } from "react-router-dom";
import styles from "../styles/authStyles.module.css";
import React, { useState } from "react";
import WelcomeTitle from "../components/WelcomeTitle";
import InputField from "../components/InputField";
import { useDispatch } from "react-redux";
import { forgotPassword } from "../../api/auth";
import LoginCarousel from "./LoginCarousel";
import { FaCreativeCommonsSa } from "react-icons/fa";
import useWindowWidth from "../../hooks/useWindowWidth";
import { isClientPreview } from "../../utils/clientPreview";
import ForgotPasswordPreview from "./ForgotPasswordPreview";

export default function NewForgotPassword() {
    const [email, setEmail] = useState("");
    const dispatch = useDispatch();
    const windowWidth = useWindowWidth()

  if (isClientPreview()) {
    return (
      <ForgotPasswordPreview
        onSubmit={(address) => dispatch(forgotPassword({ email: address })).then(({ payload }) => Boolean(payload))}
      />
    );
  }

  return (
    <div>
      <Grid container>
        <Grid item xs={windowWidth >= 932 ? 6 : 12} sx={{ height: "100vh" }}>
          <div
            style={{ height: "100vh", display: "grid", placeItems: "center" }}
          >
            <div
              style={{
                width: windowWidth <= 932 ? "60%" : "50%",
                margin: "auto",
              }}
            >
                 <WelcomeTitle
              title="Forgot Password"
              subTitle="Enter your email"
            />
            <div className={styles.form}>
              <InputField
                 label="@ Email"
                placeholder="Type your email "
                type="text"
                size="small"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <div className={styles.button_part}>
                <Button
                  variant="lightblue"
                  sx={{
                    margin: "10px auto",
                    background: "#412471",
                    boxShadow: "none",
                    "&:hover": {
                      background: "#412495",
                    },
                  }}
                  className="w-full"
                  onClick={() => dispatch(forgotPassword({ email: email }))}
                >
                  Reset Password
                </Button>
              <Link style={{textDecoration:"underline", color:"#975bff"}} to="/signin">Back to Login</Link>
              </div>
            </div>
              </div>
          </div>
        </Grid>
        {windowWidth >= 932 && (
          <Grid
            item
            xs={6}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              background:
                "linear-gradient(54deg, rgba(24,9,47,1) 0%, rgba(43,14,92,1) 100%)",
              position: "relative",
            }}
          >
            <div
              style={{
                height: "80%",
                width: "68%",
                margin: "auto",
                borderRadius: "25px",
                background:
                  "linear-gradient(54deg, rgba(65,35,112,1) 0%, rgba(79,35,153,1) 100%)",
                padding: "40px 20px",
              }}
            >
              <LoginCarousel />
              <div
                style={{
                  position: "absolute",
                  width: "66%",
                  margin: "auto",
                  textAlign: "center",
                  bottom: 0,
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent:
                      windowWidth <= 1450 ? "center" : "space-evenly",
                    color: "lightgray",
                    alignItems: "center",
                    flexDirection: windowWidth <= 1450 ? "column" : "row",
                  }}
                >
                  <h6
                    style={{
                        fontSize: windowWidth <= 1450 ?"12px" : "14px",
                      display: "flex",
                      alignItems: "center",
                      lineHeight: 1,
                      marginBottom: windowWidth <= 1450 ? 0 : "20px",
                      marginRight:"10px"
                    }}
                  >
                    <FaCreativeCommonsSa
                      style={{ transform: "ScaleX(-1)", marginRight: "5px" }}
                    />{" "}
                    <a
                      href="https://u-sendfulfillment.com/"
                      style={{ color: "lightgray", fontWeight: 300 }}
                      target="_blank"
                      rel="noreferrer"
                    >
                      2023 - All rights reserved U-Send
                    </a>
                  </h6>
                  <h6
                    style={{
                        fontSize: windowWidth <= 1450 ?"12px" : "14px",
                      lineHeight: 1,
                      marginTop: windowWidth <= 1450 ? "0px" : "20px",
                    }}
                  >
                    <a
                      style={{ color: "lightgray", fontWeight: 300 }}
                      href="/help/privacy"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Privacy Policy
                    </a>{" "}
                    -{" "}
                    <a
                      style={{ color: "lightgray", fontWeight: 300 }}
                      href="/help/terms-and-conditions"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Terms of Service
                    </a>
                  </h6>
                </div>
              </div>
            </div>
          </Grid>
        )}
      </Grid>
    </div>
  );
}
